import React from "react";

import CopyIcon from "@material-ui/icons/FileCopy";
import { copyToClipboard, dateFormatter } from "../utils";
import MaterialTable from "material-table";
import styled from "styled-components/macro";
import { useApp } from "../AppProvider";

/* material-table gives every column's sort label the direction of the ACTIVE
   column, so flipping one column flips the hover arrow on all of them. A click
   on an inactive column always sorts ascending, so its arrow should say so:
   MUI draws "asc" as a 180 degree rotation. */
const Container = styled.div`
  .MuiTableSortLabel-root:not(.MuiTableSortLabel-active)
    .MuiTableSortLabel-icon {
    transform: rotate(180deg) !important;
  }
`;

const Table = ({
  columns,
  label,
  data,
  pageSize = 10,
  isLoading = false,
  height,
  actions = [],
  options = {},
}) => {
  const { doToast } = useApp();
  return (
    <MaterialTable
      id={label}
      title={`${label} ${dateFormatter(new Date(), "MM/DD/YYYY, h:mm A")}`}
      columns={columns}
      isLoading={isLoading}
      data={data}
      editable={{}}
      components={{
        Container: (props) => <Container {...props} />,
      }}
      actions={[
        {
          icon: CopyIcon,
          tooltip: "Copy Data",
          isFreeAction: true,
          onClick: () => {
            try {
              copyToClipboard(data, columns, () =>
                doToast("success", "Data was copied to your clipboard.")
              );
            } catch (error) {
              const message = error?.message ?? "Something went wrong";
              doToast("error", message);
            }
          },
        },
        ...actions,
      ]}
      options={{
        emptyRowsWhenPaging: false,
        exportAllData: true,
        columnsButton: true,
        exportButton: true,
        pageSize: pageSize,
        pageSizeOptions: [5, 10, 30, 60],
        padding: "dense",
        searchFieldAlignment: "left",
        showTitle: false,
        maxBodyHeight: height,
        ...options,
      }}
    />
  );
};

export default Table;
